import { c as _c } from "react/compiler-runtime";
import type { ProviderReturn } from '../types';
import useSendResultSdkArgs from './use-send-result-sdk-args';
type UseFootprintProvider = {
  client: ProviderReturn;
};
const useFootprintProvider = t0 => {
  const $ = _c(13);
  const {
    client
  } = t0;
  const sendResultMutation = useSendResultSdkArgs();
  const sendResult = async (authToken, deviceResponse) => {
    if (!authToken || !deviceResponse) {
      return;
    }
    try {
      const result = await sendResultMutation.mutateAsync({
        authToken,
        deviceResponse
      });
      return result;
    } catch {
      return;
    }
  };
  client.setSendResultCallback?.(sendResult);
  let t1;
  if ($[0] !== client.auth || $[1] !== client.backButtonVisibilityChange || $[2] !== client.cancel || $[3] !== client.close || $[4] !== client.complete || $[5] !== client.getAdapterResponse || $[6] !== client.getLoadingStatus || $[7] !== client.load || $[8] !== client.on || $[9] !== client.relayToComponents || $[10] !== client.requirementChanged || $[11] !== client.resized) {
    t1 = {
      auth: client.auth,
      backButtonVisibilityChange: client.backButtonVisibilityChange,
      requirementChanged: client.requirementChanged,
      resized: client.resized,
      relayToComponents: client.relayToComponents,
      cancel: client.cancel,
      close: client.close,
      complete: client.complete,
      getAdapterResponse: client.getAdapterResponse,
      getLoadingStatus: client.getLoadingStatus,
      load: client.load,
      on: client.on
    };
    $[0] = client.auth;
    $[1] = client.backButtonVisibilityChange;
    $[2] = client.cancel;
    $[3] = client.close;
    $[4] = client.complete;
    $[5] = client.getAdapterResponse;
    $[6] = client.getLoadingStatus;
    $[7] = client.load;
    $[8] = client.on;
    $[9] = client.relayToComponents;
    $[10] = client.requirementChanged;
    $[11] = client.resized;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
};
export default useFootprintProvider;